import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services';


@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private router: Router, private authenticationService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const requestedPageState: string = state.url.split('/')[1];

    if (
      this.authenticationService.getClientId() &&
      this.authenticationService.getUserId()
    ) {
      if (requestedPageState === 'pagenotfound') {
        return true;
      }
      return true;
    }
    this.router.navigate(['/login'], {
      queryParams: {
        returnUrl: state.url
      }
    });
    return false;
  }
}
